import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import crearCuenta from './crea-tu-cuenta.jpg'
import descargarCliente from './descarga-el-cliente-.jpg'
import ComenzaJugar from './comenza-a-jugar.jpg'
import { IoLogoGameControllerA } from 'react-icons/io'
import { BsPeopleFill, BsDiscord } from 'react-icons/bs'
import { FaShieldAlt, FaGem, FaUsers, FaDownload, FaUserPlus, FaGamepad, FaMapMarkedAlt, FaShoppingCart, FaHammer, FaCrown, FaMagic, FaMountain, FaBolt, FaBullseye, FaPlayCircle } from 'react-icons/fa'
import { GiBroadsword, GiCrossedSwords, GiCastle } from 'react-icons/gi'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/swiper-bundle.css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './home.css'
import axios from 'axios';
import { Link } from 'react-router-dom';
import logo from '../layout/logo.png'
import logo2 from '../layout/Logo2.png'
import Layout from '../layout/Layout'
import muVideo from './mu.mp4'
function Home(props) {
    const [user, setUser] = useState({});
    const [news, setNews] = useState([]);
    const [generalData, setGeneralData] = useState(null);
    const [formData, setFormData] = useState({ title: '', content: '', author: '' });
    const [habilitarCrear, setHabilitarCrear] = useState();
    const [activeFeature, setActiveFeature] = useState(0);

    const fetchNews = async () => {
        try {
            const response = await axios.get('https://backmu.vercel.app/news');
            setNews(response.data);
        } catch (error) {
            console.error('Error al obtener noticias:', error);
        }
    };

    const fetchServerInfo = async () => {
        try {
            const response = await fetch('/gate/info');
            const data = await response.json();
            setGeneralData(data);
        } catch (error) {
            setGeneralData(null);
        }
    };

    const handleCreateNews = async () => {
        try {
            await axios.post('https://backmu.vercel.app/news', formData);
            fetchNews();
            setFormData({ title: '', content: '', author: '' });
            setHabilitarCrear(!habilitarCrear);
        } catch (error) {
            console.error('Error al crear noticia:', error);
        }
    };

    const handleDeleteNews = async (id) => {
        try {
            await axios.delete(`https://backmu.vercel.app/news/${id}`);
            fetchNews();
        } catch (error) {
            console.error('Error al eliminar noticia:', error);
        }
    };

    useEffect(() => {
        fetchNews();
        fetchServerInfo();
    }, []);

    const isOnline = generalData && generalData.jugadoresOnline > 0;

    const features = [
        { icon: <FaMapMarkedAlt />, label: 'Nuevo Continente...', tag: 'EXCLUSIVO', img: crearCuenta, desc: '' },
        { icon: <FaShoppingCart />, label: 'Casa de Subastas', tag: 'POPULAR', img: crearCuenta, desc: '' },
        { icon: <FaHammer />, label: 'Forja Divina', img: crearCuenta, desc: '' },
        { icon: <FaCrown />, label: 'Nuevas Monster Win...', tag: 'ÉPICO', img: crearCuenta, desc: '' },
        { icon: <FaMagic />, label: 'Motor Gráfico Optimizado', tag: 'NUEVO', img: crearCuenta, desc: '' },
        { icon: <FaMountain />, label: 'Nuevos Mapas', img: crearCuenta, desc: '' },
        { icon: <GiBroadsword />, label: 'Nuevos Sets y Armas Mastery', img: crearCuenta, desc: '' },
        { icon: <GiCrossedSwords />, label: 'Exclusivo PvP Battlegrounds', tag: 'PVP', img: crearCuenta, desc: '' },
        { icon: <GiCastle />, label: 'Dungeons Exclusivas', img: crearCuenta, desc: '' },
        { icon: <BsPeopleFill />, label: 'AutoMove & AutoParty', img: crearCuenta, desc: '' },
        { icon: <FaBolt />, label: 'Anti-freeze / Anti-lag', img: crearCuenta, desc: '' },
        { icon: <FaBullseye />, label: 'Rift Spots', img: crearCuenta, desc: '' },
    ];

    return (
        <Layout tyExpanded={props.tyExpanded} setExpanded={props.setExpanded} isMobile={props.isMobile}>
            {/* ══════════════════════════════════════════ */}
            {/*  HERO  ─  Full-width video background      */}
            {/* ══════════════════════════════════════════ */}
            <section className="hero-section">

                {/* VIDEO DE FONDO (Vimeo autoplay / silenciado / loop) */}
                <div className="hero-video-container">
                    <video
                        className="hero-video"
                        autoPlay
                        loop
                        muted
                        playsInline
                        preload="auto"
                    >
                        <source src={muVideo} type="video/mp4" />
                    </video>
                </div>

                {/* OVERLAY oscuro en degradado */}
                <div className="hero-overlay" />

                {/* CONTENIDO CENTRADO */}
                <div className="hero-content">

                    {/* Logo del servidor */}
                    <img
                        src={logo2}
                        alt="Mu Serendipia"
                        className="hero-logo"
                    />

                    {/* Slogan */}
                    <p className="hero-tagline">
                        Servidor Privado · Temporada Legendaria
                    </p>

                    {/* Estado del servidor */}
                    <div className="hero-server-badge">
                        <span className={`hero-server-dot${isOnline ? '' : ' offline'}`} />
                        <span className="hero-server-text">
                            {isOnline
                                ? `Servidor Online · ${generalData.jugadoresOnline} jugadores`
                                : 'Servidor en Mantenimiento'}
                        </span>
                    </div>

                    {/* Pills de información */}
                    <div className="hero-info-pills">
                        <div className="hero-pill">
                            <Typography style={{ color: '#fffc77', fontFamily: 'Inter', fontSize: '12px' }}>Versión:</Typography><span>Legendaria</span>
                        </div>
                        <div className="hero-pill"><Typography style={{ color: '#fffc77', fontFamily: 'Inter', fontSize: '12px' }}>Experiencia:</Typography><span>500x</span></div>
                        <div className="hero-pill"><Typography style={{ color: '#fffc77', fontFamily: 'Inter', fontSize: '12px' }}>Drop:</Typography><span>40%</span></div>
                    </div>

                    {/* Botones de acción */}
                    <div className="hero-actions">
                        <button
                            className="btn-hero-primary"
                            onClick={() => props.openAuthPopup && props.openAuthPopup(1)}
                        >
                            ⚔ Crear Cuenta
                        </button>
                        <Link to="/descargas" className="btn-hero-secondary">
                            ⬇ Descargar Cliente
                        </Link>
                    </div>
                </div>

                {/* Indicador de scroll */}
                <div className="hero-scroll-indicator">
                    <div className="hero-scroll-mouse" />
                    <span className="hero-scroll-label">Scroll</span>
                </div>
            </section>

            {/* ══════════════════════════════════════════ */}
            {/*  CONTENIDO PRINCIPAL bajo el Hero          */}
            {/* ══════════════════════════════════════════ */}
            <Grid className="home-content">

                {/* SECCIÓN: SHOWCASE DE CARACTERÍSTICAS */}
                <div className="showcase-section">
                    <Typography className="showcase-title">¿Por qué Atlas Mu?</Typography>
                    <div className="showcase-tabs">
                        {features.map((f, i) => (
                            <button
                                key={i}
                                className={`showcase-tab${activeFeature === i ? ' active' : ''}`}
                                onClick={() => setActiveFeature(i)}
                            >
                                {f.tag && <span className="showcase-tab-tag">{f.tag}</span>}
                                <div className="showcase-tab-icon-wrapper">
                                    <span className="showcase-tab-icon">{f.icon}</span>
                                    <FaPlayCircle className="showcase-tab-play" />
                                </div>
                                <span className="showcase-tab-label">{f.label}</span>
                            </button>
                        ))}
                    </div>
                    <div className="showcase-content">
                        <img
                            key={activeFeature}
                            src={features[activeFeature].img}
                            alt={features[activeFeature].label}
                            className="showcase-img"
                        />
                    </div>
                </div>

                {/* NOTICIAS + PANEL AYUDA */}
                <Grid style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: props.isMobile ? 'column' : 'row',
                    gap: props.isMobile ? '10px' : '0',
                    width: '50%',
                }}>

                    {/* ─ Noticias ─ */}
                    <Grid style={{
                        border: '1px solid #343843',
                        display: 'flex',
                        borderRadius: '5px',
                        width: props.isMobile ? '100%' : '80%',
                        flexDirection: 'column',
                        gap: '10px',
                        padding: '10px'
                    }}>
                        <Grid style={{ padding: '5px', borderBottom: '1px solid #343843' }}>
                            <Typography style={{ color: 'white' }}>Noticias</Typography>
                        </Grid>

                        <Grid style={{ padding: '5px', gap: '10px', display: 'flex', flexDirection: 'column' }}>
                            {user.rol === 'admin'
                                ? news.length >= 1
                                    ? (
                                        <Grid style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                            <button style={{ width: '30%' }} onClick={() => setHabilitarCrear(!habilitarCrear)}>
                                                {habilitarCrear ? 'Cerrar' : 'Crear Noticia'}
                                            </button>
                                            {news.map((item) => (
                                                <Grid key={item._id} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                    <Grid style={{ display: 'flex', alignItems: 'center', border: '1px solid #343843', borderRadius: '5px', padding: '5px' }}>
                                                        <Grid style={{ width: '10%', display: 'flex', justifyContent: 'center' }}>
                                                            <IoLogoGameControllerA style={{ color: 'white', fontSize: '50px', margin: '0 auto' }} />
                                                        </Grid>
                                                        <Grid style={{ width: '90%', display: 'flex', flexDirection: 'column' }}>
                                                            <Typography variant="h5" style={{ color: 'white', fontSize: '20px' }}>{item.title}</Typography>
                                                            <Typography style={{ color: 'white' }}>{item.content}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <button onClick={() => handleDeleteNews(item._id)} style={{ width: '10%' }}>Eliminar</button>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    )
                                    : (
                                        <Grid style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            <button style={{ width: '10%' }} onClick={() => setHabilitarCrear(!habilitarCrear)}>
                                                {habilitarCrear ? 'Cerrar' : 'Crear Noticia'}
                                            </button>
                                            <Typography style={{ color: 'white', fontStyle: 'italic' }}>No existen noticias en estos momentos</Typography>
                                        </Grid>
                                    )
                                : news.length >= 1
                                    ? news.map((item) => (
                                        <Grid key={item._id} style={{ display: 'flex', alignItems: 'center', border: '1px solid #343843', borderRadius: '5px', padding: '5px', gap: '10px' }}>
                                            <Grid style={{ width: '10%', display: 'flex', justifyContent: 'center' }}>
                                                <IoLogoGameControllerA style={{ color: 'white', fontSize: '50px', margin: '0 auto' }} />
                                            </Grid>
                                            <Grid style={{ width: '90%', display: 'flex', flexDirection: 'column' }}>
                                                <Typography variant="h5" style={{ color: 'white', fontSize: '20px' }}>{item.title}</Typography>
                                                <Typography style={{ color: 'white' }}>{item.content}</Typography>
                                            </Grid>
                                        </Grid>
                                    ))
                                    : (
                                        <Typography style={{ color: 'white', fontStyle: 'italic' }}>No existen noticias en estos momentos</Typography>
                                    )
                            }

                            {user.rol === 'admin' && habilitarCrear && (
                                <Grid style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <h2>Crear Noticia</h2>
                                    <input type="text" name="title" placeholder="Título" value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value })} />
                                    <textarea name="content" placeholder="Contenido" value={formData.content} onChange={(e) => setFormData({ ...formData, content: e.target.value })} />
                                    <button onClick={handleCreateNews}>Crear Noticia</button>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>

                    {/* ─ Panel de Ayuda ─ */}
                    {/* <Grid style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '15px',
                        width: props.isMobile ? '100%' : '18%',
                        padding: '20px',
                        border: '1px solid #343843',
                        borderRadius: '5px'
                    }}>
                        <BsPeopleFill style={{ color: 'white', fontSize: '50px' }} />
                        <Typography style={{ fontWeight: 600, fontSize: '24px', color: 'white', textAlign: 'center' }}>
                            ¿Necesitas ayuda?
                        </Typography>
                        <Typography style={{ fontSize: '14px', color: '#828998', textAlign: 'center' }}>
                            Soporte disponible en nuestro Discord oficial
                        </Typography>

                    </Grid> */}
                </Grid>
            </Grid>

            {/* Icono flotante de Discord */}
            <a
                href="https://discord.gg/"
                target="_blank"
                rel="noopener noreferrer"
                className="discord-floating-icon"
            >
                <BsDiscord />
            </a>
        </Layout>
    );
}

export default Home